import React from 'react';

import {
	Accordion,
	FormGroup,
	Grid2 as Grid,
	TextField,
	Typography,
	styled,
	AccordionDetails,
	AccordionSummary,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CourseDTO } from '../../../DTO/CourseDTO';
import { EntityState } from '../../../util/enumerations';
import { useApplication, useUpdateApplication } from '..';

const StyledAccordion = styled(Accordion)({
	border: '1px solid #999',
	backgroundColor: '#f6f6f6',
	boxShadow: 'none',
	marginBottom: '8px',
	borderRadius: '8px !important',
});

type InformationRowProps = {
	coursesExchange: CourseDTO[];
	rowIndex: number;
};

const InformationRows = ({
	coursesExchange,
	rowIndex,
}: InformationRowProps) => {
	const { privileges } = useApplication();
	const { updateInformationRow, updateInformationRowUrl } =
		useUpdateApplication();
	return (
		<>
			{coursesExchange
				.filter(
					(c) =>
						c.informationRow &&
						c.informationRow.state !== EntityState.Removed
				)
				.map((course, idx) => (
					<StyledAccordion
						defaultExpanded={privileges.editRows}
						key={course.id}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
						>
							<Grid container spacing={0} key={course.id}>
								<Grid size={{ xs: 10 }}>
									<Typography style={{ textWrap: 'nowrap' }}>
										<p>
											Course information{' '}
											<strong>{`(${course?.code} - ${course?.title})`}</strong>
										</p>
									</Typography>
								</Grid>
							</Grid>
						</AccordionSummary>
						<AccordionDetails>
							<div style={{ width: '100%' }}>
								<FormGroup row>
									<TextField
										id="outlined-multiline-static"
										label="Description"
										multiline
										fullWidth
										rows={4}
										disabled={!privileges.editRows}
										placeholder="Describe the course..."
										variant="outlined"
										value={course.informationRow?.note}
										onChange={(e) => {
											updateInformationRow(
												rowIndex,
												e.target.value,
												idx
											);
										}}
									/>
								</FormGroup>
								<FormGroup row>
									<TextField
										id="outlined-multiline-static"
										label="Course Description Link"
										fullWidth
										style={{ marginTop: '10px' }}
										disabled={!privileges.editRows}
										placeholder="Link to course description..."
										variant="outlined"
										value={
											course.informationRow?.externalUrl
										}
										onChange={(e) => {
											updateInformationRowUrl(
												rowIndex,
												e.target.value,
												idx
											);
										}}
									/>
								</FormGroup>
							</div>
						</AccordionDetails>
					</StyledAccordion>
				))}
		</>
	);
};

export default InformationRows;
